// start:ng42.barrel
import './subjectClass-member-list-popup.component';
// end:ng42.barrel

